import { defineMessages, useIntl } from 'react-intl';

import { useContentfulContentTypeEntry } from '@order/Contentful';
/**
 * Returns contentful data for 'Account Deletion'.
 */
export const useAccountDeletionContentfulData = () => {
  const { formatMessage } = useIntl();

  const { data: contentfulData, fetching: isLoadingContentfulData } =
    useContentfulContentTypeEntry<AccountDeletionContentfulData>({
      contentType: ACCOUNT_DELETION_CONTENTFUL_ID,
      include: 2,
    });

  return {
    isLoadingContentfulData,
    body:
      contentfulData?.fields?.step2 ??
      formatMessage(messages.accountDeleteBody),
  };
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  accountDeleteBody: {
    defaultMessage: `Click “Delete your data & account” in order to submit your request. A confirmation email will be sent to you after submitting your request. You must select "Confirm Email" to continue your account deletion. You will generally hear back from us about your request within 45 days, but in some cases it may take up to 90 days, in which case we will notify you prior to 45 days that an extension is required.

Please also note that if you request that sweetgreen delete your data, sweetgreen will need to delete your sweetgreen account entirely and that we will be unable to provide any online or digital services to you or support for past products or services that you have purchased.

If you have any other questions about the rights to your sweetgreen data, please email us at privacy@sweetgreen.com or visit our privacy policy at https://www.sweetgreen.com/privacy-policy.`,
    description: 'Account | Delete | Body',
  },
});

// ─── Constants ────────────────────────────────────────────────────

const ACCOUNT_DELETION_CONTENTFUL_ID = 'accountAccountDeletion';

// ─── Types ────────────────────────────────────────────────────────

type AccountDeletionContentfulData = Readonly<{
  step2?: string;
}>;
